import { authApiClient } from '../../../utils/axios';

export const checkEmailStatus = async (email) => {
  const url = `/check-email`;
  try {
    const response = await authApiClient.get(url, {
      params: { email },
    });
    return response.data;
  } catch (error) {
    console.error('Error calling check-email-status:', error);
    throw error;
  }
};
